import { FormControl, Select, MenuItem, Checkbox, ListItemText, SelectChangeEvent } from "@mui/material";
import { FunctionComponent, useState } from "react";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const PublishProperties: FunctionComponent<{ properties: any, onPublishProperty: any, toogle: any }> = (props) => {

    const [selectedPlatform, setSelectPlatform] = useState<any[]>([]);
    const [platforms, setPlatforms] = useState<any>([{ name: "Coralytics", src: "/assets/images/icons/coralytics.webp" }, { name: "Propcrm", src: "/assets/images/icons/propcrm.png" }, { name: "Propertyfinder", src: "/assets/images/icons/finder.png" }, { name: "Bayut", src: "/assets/images/icons/bayut.png" }, { name: "Dubizzle", src: "/assets/images/icons/dubizzle.png" }]);
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const handleClickOpen = () => {
        setSelectPlatform([]);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleChangePlatforme = (event: SelectChangeEvent<typeof selectedPlatform>) => {
        const {
            target: { value },
        } = event;

        setSelectPlatform(
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    const handlePublish = async () => {
        const listings = {
            "properties": props.properties,
            "portals": selectedPlatform,
            "publish": true
        }
        setOpen(false)
        props.onPublishProperty(listings)
    };


    return (<>
        <button type="submit" className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 padd-10-15-mb mb-3 ${props.properties.length == 0 ? "disabled" : ''}`} onClick={handleClickOpen}>
          {t('propertiesPage.publish')}
        </button>

        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={"sm"}
        >
            <DialogTitle id="customized-dialog-title">
                <div className="title-18 mt-2 "> {t('propertiesPage.titlePublish')} </div>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[800],
                    '&:hover': { backgroundColor: theme.palette.grey[400] }
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent >
                <div className="row padd-5-10">
                    <div className="col-md-12">
                        <label htmlFor="portal" className="para-16 mb-3">{t('propertiesPage.selectPortal')}</label>
                        <FormControl fullWidth>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                className="custom-select "
                                value={selectedPlatform}
                                onChange={handleChangePlatforme}
                                renderValue={(selected) => selected.join(', ')}>
                                {platforms.map((platform: any, index: any) => (
                                    <MenuItem value={platform.name} key={index}>
                                        <Checkbox checked={selectedPlatform.indexOf(platform.name) > -1} />
                                        <img src={platform.src} style={{ width: "auto", maxHeight: "20px", marginRight: "10px" }} />
                                        <ListItemText primary={platform.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <button type="button" onClick={handlePublish}  className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15 marg-right-16" ${selectedPlatform.length == 0 ? "disabled" : ''}`}>{t('propertiesPage.publish')}</button>
                <button type="button" className="button-dash btn-outline-secondary back-trans padd-15" onClick={handleClose}>
                  {t('propertiesPage.close')}
                </button>
            </DialogActions>
        </BootstrapDialog>
       
    </>
    )
}
export default PublishProperties;
